export default {
  // 页面标题
  title: '任务管理',

  // 标签页
  tabs: {
    freightImport: '运价导入',
    inquiryImport: '询价导入',
    import: '导入任务', // 保留兼容性
    export: '导出任务'  // 保留兼容性
  },

  // 搜索表单
  search: {
    fileName: '文件名',
    fileNamePlaceholder: '请输入文件名称',
    creator: '创建人',
    creatorPlaceholder: '请选择创建人',
    taskType: '来源',
    taskTypePlaceholder: '请选择来源',
    status: '状态',
    statusPlaceholder: '请选择状态',
    operationType: '操作类型',
    operationTypePlaceholder: '请选择操作类型',
    timeRange: '时间范围',
    startTime: '开始时间',
    endTime: '结束时间',
    searchButton: '搜索',
    resetButton: '重置'
  },

  // 表格标题
  table: {
    freightImportTitle: '运价导入任务列表',
    inquiryImportTitle: '询价导入任务列表',
    importTitle: '导入任务列表', // 保留兼容性
    exportTitle: '导出任务列表', // 保留兼容性
    columns: {
      fileName: '文件名称',
      source: '来源',
      operationType: '操作类型',
      creator: '创建人',
      status: '状态',
      createTime: '创建时间',
      importTime: '导入时间',
      exportTime: '导出时间',
      remark: '备注',
      action: '操作'
    }
  },

  // 状态
  status: {
    processing: '处理中',
    completed: '已完成',
    failed: '失败',
    pending: '等待中',
    stopped: '已停止',
    published: '已上架'
  },

  // 任务类型
  taskType: {
    fullContainerFreightImport: '整箱运价导入',
    prePortFreightImport: '港前运价导入',
    priceQueryExport: '运价查询导出',
    railFreightExport: '铁路运价导出',
    railSurchargeExport: '铁路附加费导出',
    railSurchargeImport: '铁路附加费导入',
    lastMileFreight: '尾程运价导入',
    lclFreightImport: '拼箱运价导入',
    airFreightImport: '空运运价导入',
    expressFreightImport: '快递运价导入',
    railFreightImport: '铁路运价导入',
    surchargeLclImport: '拼箱附加费导入',
    surchargeAirImport: '空运附加费导入',
    aICustomerAcquisitionImport: 'AI获客导入',
    portPlatformCopy: '平台港口复制',
    warehousePlatformCopy: '平台仓库复制',
    routePlatformCopy: '平台航线复制',
    surchargeFclImport: '整箱附加费导入',
    surchargePrePortImport: '港前附加费导入',
    surchargeLastMileImport: '尾程附加费导入',
    warehouseFclFreightImport: '运价库整箱运价导入',
    warehouseLclFreightImport: '运价库拼箱运价导入',
    warehouseAirFreightImport: '运价库空运运价导入',
    warehousePrePortFreightImport: '运价库港前运价导入',
    warehouseLastMileFreightImport: '运价库尾程运价导入',
    fclPriceRatio: '整箱运价配比',
    unknown: '未知类型'
  },

  // 操作类型
  operationType: {
    import: '导入',
    export: '导出',
    unknown: '未知操作'
  },

  // 来源
  source: {
    superFreight: '超级运价',
    orderCenter: '订单中心',
    customerCenter: '客商中心'
  },

  // 操作按钮
  actions: {
    view: '查看',
    download: '下载',
    delete: '删除'
  },

  // 删除对话框
  deleteModal: {
    title: '确认删除',
    content: '删除后不可恢复，确认删除？',
    confirmText: '确认删除',
    cancelText: '取消'
  },

  // 消息提示
  messages: {
    loadDataFailed: '加载数据失败',
    deleteSuccess: '删除成功',
    deleteError: '删除失败',
    downloadFile: '下载文件',
    downloadSuccess: '文件下载成功',
    downloadFailed: '文件下载失败',
    noFileToDownload: '没有可下载的文件'
  },

  // 任务详情
  detail: {
    title: '任务详情',
    importTaskDetailTitle: '导入任务详情',
    prePortImportTaskDetailTitle: '运价导入详情',
      ratioProgress: {
        title: '运价配比任务进度'
      },
    backButton: '返回任务列表',
    basicInfo: {
      title: '任务基本信息',
      taskId: '任务ID',
      fileName: '文件名称',
      source: '来源',
      creator: '创建人',
      status: '状态',
      processTime: '处理时间',
      importTime: '导入时间'
    },
    processLogs: {
      title: '处理日志'
    },
    fileInfo: {
      title: '文件信息',
      fileSize: '文件大小',
      duration: '处理耗时',
      totalRows: '总行数',
      processedRows: '已处理行数',
      errorRows: '错误行数',
      remark: '备注'
    },
    resultPreview: {
      title: '结果预览',
      remark: '备注',
      totalRows: '总行数',
      successRows: '成功行数',
      failedRows: '失败行数',
      copyMode: '复制方式',
      copyModeSync: '同步复制',
      copyModeTask: '后台任务',
      matchedCount: '匹配数量',
      requestedCount: '请求复制数量',
      excludedCount: '排除数量',
      copiedCount: '已复制数量',
      skippedCount: '跳过数量',
      failedCount: '失败数量',
      errorMessage: '错误信息'
    },
    actions: {
      downloadFile: '下载文件',
      deleteTask: '删除任务',
      directPublish: '直接上架',
      saveDraft: '存入草稿',
      delete: '删除'
    },
    table: {
      columns: {
        priceNo: '运价号',
        freightType: '运价类型',
        pol: '起运港',
        pod: '卸货港',
        pot: '中转港',
        transitType: '中转类型',
        carrier: '船公司',
        contractNo: '约号',
        cargoType: '货物类型',
        price20GP: '20GP',
        price40GP: '40GP',
        price40HC: '40HC',
        nac: 'NAC',
        creator: '创建人',
        dateCreated: '创建日期',
        validPeriod: '有效期',
        action: '操作'
      },
      freightTypes: {
        contract: '合约价',
        spot: '现货价'
      },
      transitTypes: {
        direct: '直达',
        transit: '中转'
      },
      cargoTypes: {
        general: '普货',
        dangerous: '危险品'
      },
      nacStatus: {
        yes: 'YES',
        no: 'NO'
      }
    },
    publishModal: {
      title: '确认上架',
      content: '确定要上架当前导入的所有运价吗？',
      confirmText: '确认',
      cancelText: '取消'
    },
    deleteModal: {
      title: '确认删除',
      content: '确定要删除这条运价记录吗？删除后无法恢复。',
      confirmText: '确认删除',
      cancelText: '取消'
    },
    messages: {
      loadDetailFailed: '加载任务详情失败',
      loadDataFailed: '加载运价数据失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      downloadFile: '下载文件',
      publishSuccess: '上架成功，任务状态已更新为已上架',
      publishFailed: '上架失败',
      missingTaskParam: '缺少任务参数',
      taskParamParseFailed: '任务参数解析失败',
      unknownFile: '未知文件',
      unknownCreator: '未知创建人',
      loadTaskDetailSuccess: '加载任务详情成功',
      cannotFindTaskId: '无法获取任务ID',
      apiNoValidData: 'API未返回有效数据',
      cannotFindRecord: '无法找到要删除的记录',
      decompressFailed: '解压缩失败',
      decompressJsonFailed: '解压缩JSON失败',
      noDraftData: '没有可存入草稿的数据',
      saveDraftSuccess: '已将 {count} 条记录存入草稿',
      saveDraftFailed: '存入草稿失败'
    },
    processStatus: {
      taskCreated: '任务创建',
      fileUploaded: '文件上传',
      formatValidation: '格式验证',
      dataProcessing: '数据处理',
      processCompleted: '处理完成'
    },
    dateRange: {
      to: '至',
      from: '起'
    },
    batchPublishResult: {
      title: '批量上架完成',
      titlePartialFailed: '批量上架完成（部分失败）',
      total: '总计',
      success: '成功',
      failed: '失败',
      errorDetail: '错误详情',
      moreErrors: '... 还有 {count} 条错误',
      confirm: '确定',
      unit: '条'
    },
    parsingRecord: {
      title: '解析记录详情',
      back: '返回',
      steps: {
        fileReadSuccess: '文件数据读取成功',
        batchNo: '生成批次号：{no}',
        dataCheck: '数据校验',
        checkPassed: '全部数据校验通过',
        waiting: '等待处理...',
        canceled: '已取消',
        dataMatch: '数据匹配导入规则',
        matchRate: '匹配率：{rate}%',
        importDone: '数据导入完成',
        importRate: '成功率：{rate}%'
      },
      stats: {
        totalCount: '总行数',
        parseSuccess: '解析成功',
        newCount: '新增：{count}',
        updateCount: '更新：{count}',
        parseFailed: '解析失败',
        warningCount: '提示',
        warningInfo: '提示信息',
        systemError: '系统错误'
      },
      actions: {
        confirmImport: '确认导入',
        cancelImport: '取消导入',
        downloadErrorReport: '下载错误明细'
      },
      status: {
        processingTip: '正在处理中，请稍候...'
      },
      taskRemarks: {
        processing: '正在处理运价库导入任务',
        failed: '运价库导入任务处理失败',
        completed: '运价库导入任务处理完成'
      },
      errors: {
        rowNum: '第 {row} 行',
        rowsRange: '第 {start}-{end} 行',
        rowsList: '第 {rows} 行',
        systemField: '系统',
        resultTruncated: '校验结果内容过长，已汇总并仅展示部分错误；未展示的错误行仍会被过滤。',
        duplicateData: '重复数据',
        duplicateRate: '已存在相同维度的运价',
        duplicateAirRate: '已存在相同维度的空运运价',
        duplicateLclRate: '已存在相同维度的海运拼箱运价'
      },
      messages: {
        confirmSuccess: '已确认导入',
        confirmFailed: '确认导入失败',
        cancelSuccess: '已取消导入',
        cancelFailed: '取消导入失败',
        noValidData: '文件里无有效数据',
        warehouseDirectSave: '运价库导入数据已直接落库，无需再次确认；错误行未写入，可下载错误明细修正后重传。',
        errorReportFileName: '运价库导入错误明细_{batchNo}.xlsx',
        errorReportDownloadSuccess: '错误明细下载成功',
        errorReportDownloadFailed: '错误明细下载失败'
      },
      excel: {
        fields: {
          airline: '航空公司',
          carrier: '船公司',
          polAir: '起运机场',
          podAir: '目的机场',
          polSea: '起运港',
          podSea: '卸货港',
          price: '运费单价',
          unitSea: '计费单位',
          transportTerm: '运输条款',
          tradeTerm: '贸易条款',
          validFrom: '有效期起始时间',
          validTo: '有效期结束时间',
          chargeName: '费用名称',
          supplier: '供应商',
          port: '港口',
          currency: '币种',
          paymentTerms: '付费条款',
          podRouteCategory: '卸货港航线分类',
          polRouteCategory: '起运港航线分类',
          polTerminal: '起运港码头',
          originCountry: '起运国',
          originCity: '起运城市',
          destCountry: '目的国',
          destCity: '目的城市',
          file: '文件',
          billingUnit: '费用单位',
          isTotalIncluded: '总价是否已包含',
          isCountTotal: '是否计入总价',
          pod: '卸货港',
          podRoute: '卸货港航线分类',
          pol: '起运港',
          por: '收货地',
          pdl: '目的港',
          transferPort: '中转港',
          podTerminal: '卸货港码头',
          polRoute: '起运港航线分类',
          containerPrice: '箱型价格',
          unitRate: '费用(票)',
          measure: '计量单位',
          cargoType: '货物类型',
          priceMethod: '运价类型',
          branchLine: '支线类型',
          seaRail: '海铁类型',
          province: '省',
          city: '市',
          district: '区/县',
          town: '镇/街道',
          community: '社区',
          airPort: '起运机场',
          country: '国家',
          wholeRow: '整行',
          expressSupplier: '快递运营商',
          supplierEnterpriseId: '供应商',
          accountNo: '账号',
          serviceType: '服务类型',
          origin: '发货地',
          destination: '目的地',
          originWarehouse: '发货仓库',
          destinationWarehouse: '目的仓库',
          billingModel: '计费模式',
          loadMode: '装载模式',
          billingMethod: '计费方式',
          volumetricFactor: '体积重系数',
          minBillingWeight: '最小计费重量',
          pickupFee: '提货费',
          deliveryFee: '送货费',
          loadingFee: '装卸费',
          vehicleCapacity: '车型载重',
          vehicleVolume: '车型容积',
          tripPrice: '整车一口价',
          kmPrice: '每公里单价',
          minKm: '最低里程',
          firstWeightThreshold: '首重',
          firstWeightPrice: '首重单价',
          additionalWeightUnit: '续重计量单位',
          additionalWeightPrice: '续重单价',
          unitPrice: '单价',
          weightStart: '起始重量',
          weightEnd: '结束重量',
          weightTierUnitPrice: '重量段单价',
          weightTierAdditionalPrice: '重量段续重单价',
          weightTierMinCharge: '最低收费（总价）',
          minCharge: '最低消费',
          beginDate: '有效期起始',
          endDate: '有效期截止',
          paymentTerm: '付费条款',
          transportMode: '运输方式',
          containerOwnership: '箱属',
          freeDetentionDays: '目的港免柜期',
          freeDemurrageDays: '目的港免堆期',
          externalSource: '数据来源',
          surchargeNames: '附加费名称',
          logicalRate: '逻辑运价',
          excelFormat: 'Excel格式',
          warehouseGeneric: '运价字段',
          unsupportedFields: '本期暂不导入字段'
        },
        errors: {
          notEmpty: '不能为空',
          invalidNumber: '必须为有效数值格式',
          invalidDateValue: '日期格式不正确',
          invalidInteger: '必须为非负整数或有效整数区间',
          invalidContainerOwnership: '仅支持 COC（承运人箱）或 SOC（货主箱）',
          defaultSupplierNotFound: 'Booking Agent 留空且当前租户未配置可用的默认供应商',
          noData: '未读取到有效数据行，请检查模板数据起始行',
          warehouseTemplateHeaderInvalid: '模板表头与当前运价库导入模板不匹配',
          masterDataNotFound: '未匹配到对应的系统基础数据',
          warehouseValidationFailed: '数据不符合运价库导入规则，请检查该字段',
          warehouseSaveFailed: '该条运价保存失败，请修正数据后重试',
          invalidDate: '日期格式不正确: {0}',
          invalidValue: '数值或选项值不正确: {0}',
          fileReadFailed: '读取文件数据失败: {0}',
          notFoundAirline: '系统中不存在对应的航空公司: {0}',
          notFoundCarrier: '系统中不存在对应的船公司: {0}',
          notFoundPolAir: '系统中不存在对应的起运机场: {0}',
          notFoundPodAir: '系统中不存在对应的目的机场: {0}',
          notFoundPolSea: '系统中不存在对应的起运港: {0}',
          notFoundPodSea: '系统中不存在对应的卸货港: {0}',
          notFoundUnitSea: '系统中不存在对应的计费单位: {0}',
          notFoundTransportTerm: '系统中不存在对应的运输条款: {0}',
          notFoundTradeTerm: '系统中不存在对应的贸易条款: {0}',
          notFoundChargeName: '系统中不存在对应的费用名称: {0}',
          notFoundSupplier: '系统中不存在对应的供应商: {0}',
          notFoundPort: '系统中不存在对应的港口: {0}',
          notFoundPolTerminal: '系统中不存在对应的起运港码头: {0}',
          notFoundOriginCountry: '系统中不存在对应的起运国: {0}',
          notFoundOriginCity: '系统中不存在对应的起运城市: {0}',
          notFoundDestCountry: '系统中不存在对应的目的国: {0}',
          notFoundDestCity: '系统中不存在对应的目的城市: {0}',
          notFoundPod: '系统中不存在对应的卸货港: {0}',
          notFoundPodRoute: '系统中不存在对应的卸货港航线分类: {0}',
          notFoundPol: '系统中不存在对应的起运港: {0}',
          notFoundPor: '系统中不存在对应的收货地: {0}',
          notFoundPdl: '系统中不存在对应的目的港: {0}',
          notFoundTransferPort: '系统中不存在对应的中转港: {0}',
          notFoundPodTerminal: '系统中不存在对应的卸货港码头: {0}',
          notFoundPolRoute: '系统中不存在对应的起运港航线分类: {0}',
          containerPriceRequired: '单位为「箱」时，至少需要填写一个箱型价格',
          unitRateRequired: '单价不能为空',
          notFoundMeasure: '系统中不存在对应的计量单位: {0}',
          notFoundCargoType: '系统中不存在对应的货物类型: {0}',
          dataLogicConflict: '数据逻辑冲突：是否计入总价为「是」时，总价是否已包含不能为「是」，请重新填写',
          notFoundPriceMethod: '系统中不存在对应的运价类型: {0}',
          notFoundBranchLine: '系统中不存在对应的支线类型: {0}',
          notFoundSeaRail: '系统中不存在对应的海铁类型: {0}',
          notFoundProvince: '系统中不存在对应的省: {0}',
          notFoundCity: '系统中不存在对应的市: {0}',
          notFoundDistrict: '系统中不存在对应的区/县: {0}',
          notFoundTown: '系统中不存在对应的镇/街道: {0}',
          notFoundCommunity: '系统中不存在对应的社区: {0}',
          notFoundAirPort: '系统中不存在对应的起运机场: {0}',
          multiDistrictNoTown: '区/县存在多个值时，镇/街道、社区、详细地址不能填写',
          multiTownNoCommunity: '镇/街道存在多个值时，社区、详细地址不能填写',
          multiCommunityNoDetail: '社区存在多个值时，详细地址不能填写',
          notFoundCountry: '系统中不存在对应的国家: {0}',
          multiDistrictNoDetailAddress: '区/县存在多个值时，详细地址不能填写',
          saveFailed: '保存失败: {0}',
          expressBillingModelInvalid: '计费模式不支持: {0}',
          loadModeInvalid: '装载模式不支持: {0}',
          billingMethodInvalid: '计费方式不支持: {0}',
          billingMethodNotSupported: '计费方式与装载模式不匹配: {0}',
          ftlOnlyUnitPrice: '整车模式仅支持单价计费: {0}',
          dateRangeInvalid: '生效日期不能晚于失效日期',
          weightRangeInvalid: '结束重量必须大于起始重量: {0}',
          expressSupplierNotFound: '系统中不存在对应的快递运营商: {0}',
          supplierEnterprise: {
            accountRequired: '缺少关联账号，无法匹配供应商',
            accountUnknown: '运营商【{0}】的账号【{1}】没有供应商对应关系，请核对',
            notFound: '客商中心没有匹配到启用的供应商【{0}】，请核对',
            ambiguous: '客商中心存在多个同名供应商【{0}】，无法唯一确定',
            conflict: '关联账号【{0}】对应不同供应商，无法入库'
          },
          expressServiceTypeNotSupported: '当前快递运营商不支持服务类型: {0}',
          cargoTypeNotFound: '系统中不存在对应的货物类型: {0}',
          warehouseNotFound: '当前租户不存在对应的启用仓库: {0}',
          templateSheetNotFound: '未找到快递运价导入模板工作表',
          templateHeaderInvalid: '快递运价导入模板表头与客户模板不一致',
          serviceTypeInvalid: '服务类型无法识别: {0}',
          paymentTermInvalid: '付费条款无法识别: {0}',
          currencyNotFound: '系统中不存在对应的币种: {0}',
          countryNotFound: '地址中未匹配到国家基础数据: {0}',
          surchargeFormatInvalid: '附加费格式不正确: {0}',
          surchargeFeeNotFound: '系统中不存在对应的附加费名称: {0}',
          surchargeUnitNotFound: '系统中不存在对应的附加费计费单位: {0}',
          surchargePriceInvalid: '附加费价格必须为有效非负数: {0}',
          surchargePercentageNotAllowed: '附加费【{0}】不支持百分比计价',
          weightTierGroupIncomplete: '同一重量段逻辑运价存在错误行，整组不导入',
          weightTierPriceModeInvalid: '重量段仅允许填写单价（续重单价可选）或最低收费（总价），未使用的价格字段必须留空',
          weightTierSurchargeConflict: '同一重量段逻辑运价的附加费内容不一致',
          weightTierOverlap: '同一逻辑运价的重量段存在重复或重叠',
          logicalRateSaveFailed: '逻辑运价保存失败，请根据任务错误信息检查数据',
          excelFormat: 'Excel格式'
        },
        warnings: {
          unsupportedFields: '字段【{0}】本期暂不导入，已忽略',
          warehouseUnsupportedField: '该字段当前暂不导入，已忽略',
          warehouseTaxMerged: '含税与不含税附加费已合并保存，当前运价模型不区分税属性',
          countryNotMatched: '未匹配到地址【{0}】的国家基础数据，已按原地址保存',
          accountNoNotConfigured: '账号【{0}】不在快递运营商账号配置中，已按原值保存',
          transportModeNotStored: '运输方式【{0}】仅用于重量段分组，未结构化保存',
          addressHierarchyNotMatched: '地址层级【{0}】未匹配基础数据，已保留在详细地址'
        }
      }
    }
  }
}
